export default __webpack_public_path__ + "static/media/n-back-visivo-step2.0099807a.svg";